export const USER_NAME_MAX_LENGTH = 150;
